import { RootState } from 'store';
import { SelectedStationPricesMap } from '../../types';

import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useServicePetrolLeafs } from 'store/features/directories/selectors/services';

import {
  checkIsLoadingDone,
  checkIsLoading,
  checkIsLoadingAbort
} from 'common/utils/checkLoading';

import { EMPTY_ARRAY } from 'shared/constants';
import { STATIONS_STATE } from '../../constants';
import { PAYMENT_TYPES } from 'common/constants/paymentTypes';

export const useSelectedStation = () => {
  const selectedStation = useSelector((state: RootState) => state[STATIONS_STATE].selectedStation.data);
  return selectedStation;
};

export const useSelectedStationLoadingStatus = () => (
  useSelector((state: RootState) => state[STATIONS_STATE].selectedStation.loadingStatus)
);

export const useIsSelectedStationDone = () => {
  const selectedStationLoadingStatus = useSelectedStationLoadingStatus();
  return checkIsLoadingDone(selectedStationLoadingStatus);
};

export const useIsSelectedStationAbort = () => {
  const selectedStationLoadingStatus = useSelectedStationLoadingStatus();
  return checkIsLoadingAbort(selectedStationLoadingStatus);
};

export const useIsSelectedStationLoading = () => {
  const selectedStationLoadingStatus = useSelectedStationLoadingStatus();
  return checkIsLoading(selectedStationLoadingStatus);
};

export const useSelectedStaitonPrices = () => (
  useSelector((state: RootState) => state[STATIONS_STATE].selectedStation.prices)
);

export const useSelectedStationPricesLoadingStatus = () => (
  useSelector((state: RootState) => state[STATIONS_STATE].selectedStation.pricesLoadingStatus)
);

export const useIsSelectedStationPricesAbort = () => {
  const selectedStationPricesLoadingStatus = useSelectedStationPricesLoadingStatus();
  return checkIsLoadingAbort(selectedStationPricesLoadingStatus);
};

export const useIsSelectedStationPricesLoading = () => {
  const selectedStationPricesLoadingStatus = useSelectedStationPricesLoadingStatus();
  return checkIsLoading(selectedStationPricesLoadingStatus);
};

export const useIsSelectedStationPricesDone = () => {
  const selectedStationPricesLoadingStatus = useSelectedStationPricesLoadingStatus();
  return checkIsLoadingDone(selectedStationPricesLoadingStatus);
};

export const useSelectedStaitonPricesMap = () => {
  const selectedStaitonPrices = useSelectedStaitonPrices() || EMPTY_ARRAY;

  const selectedStaitonPricesMap = useMemo(() => (
    selectedStaitonPrices.reduce((acc, item) => {
      acc[item.service.code] = item;
      return acc;
    }, {} as SelectedStationPricesMap)
  ), [selectedStaitonPrices]);

  return selectedStaitonPricesMap;
};

export const useIsOnlyE100MobilityPayment = () => {
  const { paymentTypes = [] } = useSelectedStation() || {};

  return !!(
      paymentTypes.length === 1
      && paymentTypes[0].code === PAYMENT_TYPES.E100Mobility
  );
};


export const useSelectedStationFuelServices = () => {
  const servicePetrolLeafs = useServicePetrolLeafs();
  const { services = EMPTY_ARRAY } = useSelectedStation() || {};

  const stationInfoFuelServices = useMemo(() => (
    services.filter(({ code }) => !!servicePetrolLeafs.find(item => item.code.toString() === code.toString()))
  ), [
    services,
    servicePetrolLeafs
  ]);

  return stationInfoFuelServices;
};

export const useSelectedStationFuelServiceList = () => {
  const selectedStationFuelServices = useSelectedStationFuelServices();

  const stationInfoFuelServiceList = useMemo(() => selectedStationFuelServices.map(({
    name,
    code
  }) => ({
    key: code,
    value: name
  })), [selectedStationFuelServices]);

  return stationInfoFuelServiceList;
};
